<template>
    <datepicker :highlighted="highlightedFn"
        :disabled-dates="disabledDates"
        :format="format"
        :language="languages['ptBR']"
        v-model="date"></datepicker>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'
    import * as lang from 'vuejs-datepicker/src/locale';
    export default {
        components: { Datepicker },
        props: {
            value: { type: Date },
            format: {
                type: String,
                default: 'd de MMMM de yyyy'
            },
        },
        data () {
            return {
                languages: lang,
                highlightedFn : {
                    customPredictor(date) {
                        let today = new Date()
                        return date.getDate() == today.getDate() 
                            && date.getMonth() == today.getMonth()
                            && date.getFullYear() == today.getFullYear();
                    }
                },
                disabledDates: {
                    from: new Date()
                }
            }
        },
        computed: {
            date: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit('input', val);
                }
            }
        },
    }
</script>
